export const USER_IS_NOT_AUTHORIZED_ACTION = 'USER_IS_NOT_AUTHORIZED';
